























import {Vue, Component, Prop, Watch} from "vue-property-decorator";
import {SDynamicComponent} from '@/components/dto/SDynamicComponent';
import {SComponentIdentity} from "@/components/dto/SComponentIdentity";
import DynamicComponents from '@/components/DynamicComponents.vue';
import {Drop} from "vue-drag-drop";
import draggable from 'vuedraggable';
import {ScomponentMode} from "@/components/dto/ScomponentMode";
@Component({
    components: {DynamicComponents, Drop, draggable}
})
export default class DropComponents extends Vue {
    @Prop() schema!: SDynamicComponent[];
    @Prop() data!: any;
    @Prop() componentMode!: ScomponentMode;
    private over: boolean = false;
    private enabled: boolean = true;
    private dragging: boolean = false;

    handleDrop(data: any, event: any) {
        this.over = false;
       if(!this.dragging){
            this.$emit('callfunction', 'handleDrop', 'root');
           event.stopPropagation();
       }
    }

    handle_function_call(e:any, param:any) {
        this.$emit('callfunction', e, param);
    }

}
